// Build an object of key value pairs from an array
// incrementing the number of occurences
// of a particular value
// Support up to one level down, i.e. key1.key2 as dataKey

// Example
// Input: countBy({ data: [{ id: 'a' }, { id: 'b' }, { id: 'a' }], dataKey: 'id' })
// Output: { a: 2, b: 1 }
export const countBy = ({ data = [], dataKey = '' }) =>
  data.reduce((acc, item) => {
    const splitIems = dataKey.split('.');
    const matchingKeys = splitIems.length === 1 ? item?.[dataKey] : item?.[splitIems[0]]?.[splitIems[1]];
    if (matchingKeys) {
      if (!acc[matchingKeys]) acc[matchingKeys] = 0;
      acc[matchingKeys] += 1;
    }
    return acc;
  }, {});
